import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      assignments: {
        selector: "Create as assignment",
        yes: "Yes",
        no: "No",
        points: "Max points",
        ratingProportion: "Grade weighting",
        add: "Add Assignment",
        autoCloseDate: "Scheduled close",
        autoReleaseDate: "Scheduled results release",
        autoSendDate: "Scheduled send",
        autoEmptyDate: "Not set",
        assignment: "Assignment",
        confirmDelete: "Are you sure you want to delete {{name}} assignment?",
        dueDate: "Due date",
        events: {
          assignmentChange: "Assignment creation {{assignment}}",
          assignmentGradingChange:
            "Assignment grading changed to {{assignmentGradingMode}}",
          assignmentPointsChange: "Assignment points changed to {{points}}",
          assignmentRatingProportionChange:
            "Assignment award weighting changed to {{assignmentRatingProportion}}",
          cancelSchedule: "Scheduled assignment was cancelled",
          close: "Assignment closed",
          closeDateChange: "Scheduled close date changed to {{date}}",
          dueDateChange: "Due date changed to {{date}}",
          loopStudentChange: "Closing the loop with students {{enabled}}",
          loopInstructorChange: "Closing the loop with instructors {{enabled}}",
          loopSettingsChange:
            "Loop settings updated - student: {{student}}, instructor: {{instructor}}",
          schedule: "Assignment scheduled",
          send: "Assignment sent",
          sendDateChange: "Scheduled send date changed to {{date}}",
          reopen: "Assignment reopened",
          release: "Assignment results released",
          releaseDateChange: "Scheduled release date changed to {{date}}",
          sectionChange: "Section changed to {{section}}",
          templateChange: "Library changed to {{template}}",
        },
        menu: {
          viewSurvey: "View Assignment",
          sendButton: "Send",
          cancelSchedule: "Cancel Schedule",
          reopen: "Reopen",
          releaseResults: "Release Results",
          resultsReleased: "Results released. Click to undo.",
          unreleaseResults: "Retract Results",
          schedule: "Schedule",
          sendReminder: "Send Reminder",
          close: "Close",
          delete: "Delete",
        },
        label: "Assignment name",
        teamCount: "Teams included",
        teamSet: "Group category",
        loopSettings: "Loop Settings",
        loopInstructor: "Close the loop with instructors",
        loopStudent: "Close the loop with students",
        loopInstructorHint:
          "Allows instructors to write a response to students about their received feedback",
        loopStudentHint:
          "Prompts students to respond to the feedback they receive in their released results report",
        groups: {
          active: "Active assignments",
          draft: "Draft assignments",
          closed: "Closed assignments",
          scheduled: "Scheduled assignments",
        },
      },
      assignmentsGrading: {
        selector: "Grade this assignment",
        fixedAutomatic: "Auto graded",
        manual: "Grade manually in the LMS",
        mode: {
          FA: "Auto graded",
          MN: "Grade manually in the LMS",
        },
      },
      surveys: {
        add: "Add Survey",
        wait: {
          scheduling: "Scheduling survey...",
          sending: "Sending survey...",
        },
        analysis: {
          export: {
            rawData: {
              button: "Raw Data",
              fileType: "CSV",
            },
            averagedResults: {
              button: "Averaged Results",
              fileType: "CSV",
            },
            releasedResults: {
              button: "Released Results",
              fileType: "PDF",
            },
          },
        },
        autoCloseDate: "Scheduled close",
        autoReleaseDate: "Scheduled results release",
        autoSendDate: "Scheduled send",
        autoEmptyDate: "Not set",
        survey: "Survey",
        confirmDelete: "Are you sure you want to delete {{name}} survey?",
        dueDate: "Due date",
        events: {
          assignmentChange: "Assignment creation {{assignment}}",
          assignmentGradingChange:
            "Assignment grading changed to {{assignmentGradingMode}}",
          assignmentPointsChange: "Assignment points changed to {{points}}",
          assignmentRatingProportionChange:
            "Assignment award weighting changed to {{assignmentRatingProportion}}",
          surveyChange: "Survey creation {{survey}}",
          cancelSchedule: "Scheduled survey was cancelled",
          close: "Survey closed",
          closeDateChange: "Scheduled close date changed to {{date}}",
          dueDateChange: "Due date changed to {{date}}",
          loopStudentChange: "Closing the loop with students {{enabled}}",
          loopInstructorChange: "Closing the loop with instructors {{enabled}}",
          loopSettingsChange:
            "Loop settings updated - student: {{student}}, instructor: {{instructor}}",
          schedule: "Survey scheduled",
          send: "Survey sent",
          sendDateChange: "Scheduled send date changed to {{date}}",
          reopen: "Survey reopened",
          release: "Survey results released",
          releaseDateChange: "Scheduled release date changed to {{date}}",
          sectionChange: "Section changed to {{section}}",
          templateChange: "Library changed to {{template}}",
        },
        menu: {
          viewSurvey: "View Survey",
          sendButton: "Send",
          cancelSchedule: "Cancel Schedule",
          reopen: "Reopen",
          releaseResults: "Release Results",
          resultsReleased: "Results released. Click to undo.",
          unreleaseResults: "Retract Results",
          schedule: "Schedule",
          sendReminder: "Send Reminder",
          close: "Close",
          delete: "Delete",
        },
        label: "Survey name",
        teamCount: "Teams included",
        teamSet: "Group category",
        loopSettings: "Loop Settings",
        loopInstructor: "Close the loop with instructors",
        loopStudent: "Close the loop with students",
        loopInstructorHint:
          "Allows instructors to write a response to students about their received feedback",
        loopStudentHint:
          "Prompts students to respond to the feedback they receive in their released results report",
        yes: "Yes",
        no: "No",
        syncTeams: {
          button: "Update Teams",
          tooltip: "Import teams and sections from your LMS",
          dialogTitle: "Sync Teams",
          dialogContent:
            "Refresh this survey with the latest teams from your LMS?",
          dialogCancel: "Cancel",
          dialogRefresh: "Refresh Teams",
        },
        groups: {
          active: "Active surveys",
          draft: "Draft surveys",
          closed: "Closed surveys",
          scheduled: "Scheduled surveys",
        },
      },
      courses: {
        course: "Course",
      },
      sections: {
        section: "Section",
      },
      templates: {
        add: "Add New",
        global: "Provided by Feedback Loop",
        institution: "Shared by your institution",
        label: "Name",
        template: "Template",
        rubric: "Rubric",
        your: "Created by you",
        snapshot:
          "You're viewing a snapshot of this template as it was sent with a survey.",
        type: {
          survey: "Survey Template",
          rubric: "Rubric",
          all: "All",
        },
      },
      categories: {
        category: "Group Category",
        label: "Group Category Name",
        deleteCategory: "Delete Category",
        deleteCategoryDisabled:
          "Only empty categories can be deleted. Remove all questions to delete.",
        deleteCategoryNotOwner:
          "You can only delete categories from your own templates.",
      },

      breadcrumbs: {
        campaigns: "Team Review",
        yourSurveys: "Your Surveys",
        templates: "Library",
        teams: "Teams",
        teamList: "Get Started",
      },
      navigation: {
        campaigns: "Campaigns",
        surveys: "Team Review",
        assignments: "Assignments",
        submissions: "Work Review",
        teams: "Teams",
        templates: "Library",
        admin: "Admin",
        courseView: "Course View",
        adminTools: "Admin Tools",
        dashboard: "Dashboard",
        settings: "Settings",
      },
      errorPage: {
        title:
          "Sorry about that! Something went wrong. Please check the URL and try again.",
        primaryCta: "Back to Home",
        secondaryCta: "Show Details",
      },
      modals: {
        releaseConfirmation: {
          title: "Release Results",
          body: "Releasing results provides a tailored report to students that details their performance within their team and contrasts it with any self ratings they have completed.",
          cancel: "Cancel",
          confirm: "Release Results",
        },
        importModal: {
          enableSyncTitle: "Enable automatic team sync?",
          connectTitle: "Connect your {{lmsType}} account",
          connectError: "Failed to connect to LMS. Please try again.",
          oauthError: "OAuth connection failed",
          enableSyncBody:
            "Would you like to enable automatic course section and group sync with your LMS?",
          connectBody:
            "We need to pair with your {{lmsType}} account to enable automatic course section and group sync.",
          cancel: "Cancel",
          proceed: "Proceed",
          connecting: "Connecting...",
          login: "Login with {{lmsType}}",
        },
        gradePushModal: {
          pushTitle: "Enable enhanced grade sync?",
          sendTitle: "Connect your LMS for enhanced grade sync before sending?",
          scheduleTitle:
            "Connect your LMS for enhanced grade sync before scheduling?",
          connectError: "Failed to connect to LMS. Please try again.",
          oauthError: "OAuth connection failed",
          pushBody:
            "Use your LMS API to push all grades in bulk for faster, more reliable sync. You can authorize now, or continue with the standard LTI-based push.",
          sendBody:
            "Connect now to automatically track assignment submissions and lateness as students submit, making final grade sync seamless.",
          scheduleBody:
            "Before scheduling, connect your LMS so we can track submissions and late penalties automatically once students start submitting.",
          skip: "Skip for now",
          connecting: "Connecting...",
          login: "Login with {{lmsType}}",
          lmsFallback: "LMS",
        },
        matchingPreviewModal: {
          appliedTitle: "Applied Teams",
          reviewTitle: "Review & Finalize Teams",
          matchedChip: "{{percent}}% matched without conflicts",
          doneEditing: "Done Editing",
          editTeams: "Edit Teams",
          editAriaDone: "done editing",
          editAriaEdit: "edit teams",
          editModeAlertTitle: "Edit mode:",
          editModeAlertBody:
            "Drag members between team boxes to reassign them. Save your changes before applying.",
          unsavedChanges: "(unsaved changes)",
          reviewInstructions:
            "Review the proposed teams below. Click <0>Edit Teams</0> to drag members between teams. When ready, click <1>Finalize Teams</1> to create groups in the course.",
          modifiedChip: "modified",
          assignToTeamAria: "Assign to team",
          memberCount_one: "{{count}} member",
          memberCount_other: "{{count}} members",
          close: "Close",
          saving: "Saving…",
          saveAdjustments: "Save Adjustments",
          finalizeTeams: "Finalize Teams",
          syncing: "Syncing…",
          syncToLms: "Sync to LMS",
          syncedToLms: "Synced to LMS",
          lmsSyncUnsupported:
            "Teams saved locally. Assign students to groups manually in your LMS.",
          adjustmentsSaved: "Team adjustments saved.",
          defaultGroupSetName: "Matching Teams",
          applyDialogPrompt: "How should teams be created in the course?",
          createNewGroupSet: "Create new group set",
          groupSetName: "Group set name",
          groupSetNameAria: "group set name",
          replaceExistingGroupSet: "Replace existing group set",
          groupSet: "Group set",
          existingGroupSetAria: "existing group set",
          noGroupSets: "No group sets found",
          back: "Back",
          finalizing: "Finalizing…",
          confirmFinalizeAria: "confirm finalize teams",
        },
        matchingRespondentsModal: {
          title: "Survey Responses",
          searchPlaceholder: "Search by name or email…",
          noMatches: "No matches found.",
          noStudents: "No students enrolled yet.",
          responded: "Responded",
          notResponded: "Not responded",
          openSurveyTooltip: "Open survey as this student",
          showingFiltered: "Showing {{filtered}} of {{total}} students",
          totalCount_one: "{{count}} student total",
          totalCount_other: "{{count}} students total",
          respondedSuffix: "{{count}} responded",
        },
        matchingWizard: {
          stepSelect: "Select Preferences",
          stepConfigure: "Configure Run",
          stepReview: "Review & Send",
          settingsTitle: "Matching Run Settings",
          labelConfiguration: "Configuration",
          labelTeamStructure: "Team structure",
          teamsCount: "{{count}} teams",
          studentsPerTeam: "{{count}} students per team",
          labelSurveyDue: "Survey due",
          noDeadline: "No deadline set",
          labelReminderEmails: "Reminder emails",
          enabled: "Enabled",
          disabled: "Disabled",
          messageToStudents: "Message to students",
          surveyQuestions: "Survey Questions",
          weightLabel: "Weight: {{weight}}/10",
          cancelMatching: "Cancel Matching",
          cancelMatchingAria: "cancel matching",
          close: "Close",
          wizardTitle: "Set Up Team Matching",
          step0Intro:
            "Choose a saved matching preferences template or create a new one. Only templates appear here.",
          editConfigTooltip: "Edit this configuration",
          editConfigAria: "edit config {{name}}",
          deleteConfigTooltip: "Delete this configuration",
          deleteConfigAria: "delete config {{name}}",
          questionCount_one: "{{count}} question",
          questionCount_other: "{{count}} questions",
          noTemplates: "No saved templates yet — create one below.",
          newPreferences: "New Matching Preferences",
          randomizing: "Randomizing…",
          randomizeTeams: "Randomize Teams",
          defineTeamStructure: "Define team structure",
          teamSizeToggle: "Team size",
          teamCountToggle: "# of teams",
          studentsPerTeamLabel: "Students per team",
          numberOfTeamsLabel: "Number of teams",
          surveyDueDateLabel: "Survey due date",
          reminderSwitchLabel: "Send reminder emails to non-responders",
          messageLabel: "Message to students (optional)",
          messageHelper:
            "Shown in the survey email and at the top of the survey form.",
          reviewHeading: "Review before sending",
          surveyCloses: "Survey closes",
          reminders: "Reminders",
          launchBlurb:
            "Clicking <1>Send Matching Survey</1> will send a personalized email invitation to every student in this course. Each student receives a unique link to complete the survey.",
          unexpectedError: "An unexpected error occurred.",
          cancel: "Cancel",
          back: "Back",
          next: "Next",
          sending: "Sending…",
          sendSurvey: "Send Matching Survey",
        },
        matchingConfigEditor: {
          editTitle: "Edit Matching Preferences",
          newTitle: "New Matching Preferences",
          nameLabel: "Preferences Name",
          saveAsTemplate: "Save as reusable template",
          descriptionLabel: "Description",
          descriptionHelper:
            "Describe when to use this template so you can find it later.",
          surveyQuestions: "Survey Questions",
          questionsHelper:
            "Drag to reorder. Set each question's team affinity (diverse vs similar) individually.",
          previewSurvey: "Preview Survey",
          addQuestion: "Add Question",
          maxCriteria: "Maximum 4 criteria",
          noQuestions: "No questions yet. Add at least one question.",
          moveUp: "Move up",
          moveDown: "Move down",
          removeQuestion: "Remove question",
          deleteAria: "Delete question",
          questionLabel: "Question Label",
          descriptionOptional: "Description (optional)",
          roleOptionsHeading: "Role options (up to {{max}})",
          addRole: "Add role",
          addRoleAria: "add role",
          addRolePrompt: "Enter role name:",
          genderOptionsHeading: "Gender options (up to {{max}})",
          addGenderOptionAria: "add gender option",
          addGenderOptionPrompt: "Enter gender option:",
          customOptionsHeading: "Answer choices (students pick one)",
          optionPlaceholder: "Option {{index}}",
          optionAria: "option {{index}}",
          removeOptionAria: "remove option {{index}}",
          addOption: "Add option",
          addOptionAria: "add option",
          teamAffinity: "Team affinity",
          balancedTooltip:
            "Balanced means this criterion has no effect on matching. Move the slider off center to use it.",
          markDiverse: "Diverse",
          markBalanced: "Balanced",
          markSimilar: "Similar",
          affinitySliderAria: "team affinity for question {{index}}",
          cancel: "Cancel",
          saving: "Saving…",
          savePreferences: "Save Preferences",
          chooseQuestionType: "Choose a question type",
          previewTitle: "Survey Preview",
          previewBody:
            "This is what students will see when they receive the survey.",
          previewClose: "Close",
          noLabelFallback: "(no label)",
          previewSearchHint: "Search classmates by name (optional)",
          previewNoOptions: "(no options yet)",
          previewAndMore: "…and more",
          affinityMaxDiversity: "Maximize diversity",
          affinityPreferDiverse: "Prefer diverse",
          affinityBalanced: "Balanced",
          affinityPreferSimilar: "Prefer similar",
          affinityMaxSimilarity: "Maximize similarity",
          questionTypeLabels: {
            timeAvailability: "Time Availability",
            rolePreference: "Role Preference",
            personality: "Personality Type",
            preferredTeammates: "Preferred Teammates",
            avoidTeammates: "Avoid Teammates",
            gender: "Gender",
            customText: "Custom Question",
          },
          questionTypeSublabels: {
            timeAvailability:
              "Students pick available day/time slots from a 7×3 weekly grid",
            rolePreference:
              "Students select their preferred team role from a predefined list",
            personality:
              "Students select their dominant Big Five personality trait",
            preferredTeammates:
              "Students list specific classmates they'd like to work with",
            avoidTeammates:
              "Students list specific classmates they'd prefer not to work with",
            gender:
              "Students select their gender from a list you can extend with additional options",
            customText:
              "A single-select multiple-choice question you write yourself",
          },
          defaultLabels: {
            timeAvailability: "When are you available to meet?",
            rolePreference: "What role do you prefer?",
            personality: "What is your personality type?",
            preferredTeammates: "Are there classmates you'd like to work with?",
            avoidTeammates:
              "Are there classmates you'd prefer not to work with?",
            gender: "What is your gender?",
            customText: "New question",
          },
          defaultDescriptions: {
            timeAvailability: "Select all time slots that work for you.",
            rolePreference: "Select the role you would most like to take on.",
            personality:
              "Choose the trait that best describes your dominant personality characteristic.",
          },
          defaultConfigName: "Team Matching Config",
        },
        licenseGate: {
          optInTitle: "Access not yet available",
          optInBody:
            "You are not on the inclusive access list for this course. Please opt in via the bookstore. After the opt-in period, your instructor will update access. If you have already opted in, contact your instructor.",
          optOutTitle: "Access not available",
          optOutBody:
            "You have opted out of inclusive access for this course. If this is an error, please contact your instructor or the bookstore to update your status.",
          continue: "Continue",
          loading: "Loading...",
        },
        licenseClaim: {
          title: "License Required",
          body: "Please provide the Feedback Loop license token you purchased in order to continue.",
          tokenLabel: "License Token",
          continue: "Continue",
        },
        userAssignmentSubmission: {
          attachmentTitle: "Assignment Attachment",
          closeAria: "close",
          downloadAria: "download",
        },
        submissionPreview: {
          closeAria: "close",
          download: "Download",
        },
      },
      errors: {
        updateAssignmentPoints: "Failed to update points for assignment",
        forms: {
          get: "Failed to load form",
          list: "Failed to load form",
          create: "Failed to create a new form",
          update: "Failed to save changes to the form",
          delete: "Failed to delete the form",
          share: "Failed to share the form",
          clone: "Failed to clone the form",
        },
        sections: {
          list: "Failed to load sections",
        },
        users: {
          list: "Failed to load users",
        },
        campaigns: {
          get: "Failed to load the campaign",
          list: "Failed to load campaigns",
          create: "Failed to create a new campaign",
          update: "Failed to save changes to the campaign",
          delete: "Failed to delete the campaign",
          sendReminder: "Failed to schedule/send the campaign reminder",
          setGroupCategory: "Failed to set the category for the group",
          pushGrades: "Failed to post grades for the campaign",
          updateAssignmentPoints: "Failed to update points for assignment",
        },
        groups: {
          create: "Failed to create new group",
          update: "Failed to save changes to the group",
          delete: "Failed to delete the group",
          list: "Failed to load groups",
          categories: {
            list: "Failed to load categories for group",
          },
          exclude: "Failed to exclude the group",
          setLeader: "Failed to set the group leader",
        },
        responses: {
          get: "Failed to load the response",
          list: "Failed to load responses for the campaign",
          update: "Failed to save changes to the response",
          delete: "Failed to delete the response",
          getSummary: "Failed to load summary of responses",
          currentUser: "Failed to load your responses",
        },
        results: {
          list: "Failed to load results for campaign",
        },
        courses: {
          get: "Failed to load course",
          sync: "Failed to sync the course information",
          setMode: "Failed to update the course's mode",
        },
        licenses: {
          claim: "Failed to claim license",
        },
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
});

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export default i18n;
